import { Modal, Tab, Tabs, Tooltip, Overlay } from "react-bootstrap";
import { useEffect, useState, useRef } from "react";
import dayjs from "dayjs";
import es from "dayjs/locale/es";
import relativeTime from 'dayjs/plugin/relativeTime'
import Prioridad from "../../../components/catalogo/Prioridad";
import { FormikProvider, useFormik } from "formik";
import EstatusTask from "../../../components/catalogo/EstatusTask";
import {FinProyectado, InicioProyectado} from "../../../components/catalogo/CatalogosTareas";
import FormTarea from "../FormTarea";
import {useToast} from "../../../components/notificaciones/ToastProvider";
import ArchivosAdjuntos from "./ArchivosAdjuntos";
import Comentarios from "./Comentarios";
import Miembros from "./Miembros";
import Subtareas from "./Subtareas";
import { axiosInstance } from "../../../components/helpers/axiosInstance"
import Progress from 'rsuite/Progress';
import 'rsuite/Progress/styles/index.css';
import TitleTooltip from "../../../components/helpers/TitleTooltip";
import MiembrosMap from "../../../components/helpers/MiembrosMap";

/**
 *
 * @param idTask
 * @param toggleShow
 * @param itChange
 * @param setItChange
 * @returns {JSX.Element}
 * @constructor
 */
export default function PerfilTarea({
    idTask,
    toggleShow,
    setItChange,
    show,
    setShow,
    deleteTab
}) {
    const [task, setTask] = useState({});
    const [edit, setEdit] = useState(true);
    const [archivosAD, setArchivosAD] = useState([]);
    const [showMiembros, setShowMiembros] = useState(false);
    const [addSubT, setAddSubT] = useState(false);
    const [showPause, setShowPause] = useState(false);
    const [motivoPausa, setMotivoPausa] = useState("");
    const auth = JSON.parse(sessionStorage.getItem("user"));
    const toast = useToast();
    const target = useRef(null);
    const [pop, setPop] = useState(false);

    /**
     * @param task.tareas_padre
     * @param task.creada_por
     * @param task.id_miembro
     * @param task.nombre_usuario
     * @param task.avatar
     * @param task.id_archivo
     * @param task.nombre_archivo
     * @param task.fecha_subida
     * @param task.creado
     * @param task.descripcion
     * @param task.dias_proyectados
     */

    useEffect(() => {
        if (!isNaN(Number(idTask))) {
            axiosInstance.get('/todo/tareas/' + idTask)
                .then(res => {
                    setTask(res.data.tarea);
                    setArchivosAD(res.data.tarea.archivos_adjuntos);
                    //setChangeProgreso(res.data.tarea.progreso);
                })
                .catch(err => console.error(err));
        }
    }, [idTask, toast.arrayToast]);

    dayjs.locale(es);
    dayjs.extend(relativeTime);

    const asignado = task.miembros?.find((a) => a.rol === "Responsable") ?? null;

    function onSubmit(values) {
        axiosInstance.put('/todo/tareas/', {
            id_tarea: idTask,
            tarea: values.tarea,
            progreso: values.progreso,
            objetivo: values.objetivo,
            notas: values.notas,
            prioridad: values.prioridad,
            inicio_proyectado: values.inicio_proyectado,
            termino_proyectado: values.termino_proyectado,
            estatus : {
                id_origen: task.estatus ?? 1,
                id_destino: formik.values.id_estatus
            }

        }).then((res) => {
            if (res.data.result === "Tarea actualizada correctamente") {
                /////////// Cuando el estatus cambia a En pausa ///////////
                if (formik.values.id_estatus === 3 && task.estatus !== formik.values.id_estatus) {
                    setShowPause(true);
                }
                ////////// Sí se hizo correctamente el cambio se cierra el tab ////////////
                if (show) {
                    deleteTab(idTask);
                    setTimeout(() => {
                        setEdit(false);
                        toast.setArrayToast(
                            prevState => [
                                ...prevState,
                                {
                                    id : idTask,
                                    text : 'La tareas: ' + values.tarea + ' se ha actualizo correctamente',
                                    color : 'succes',
                                    show : true
                                }
                            ]
                        );
                        formik.setSubmitting(false);
                    }, 1000);
                } else {
                    setEdit(false);
                    toast.setArrayToast(
                        prevState => [
                            ...prevState,
                            {
                                id : idTask,
                                text : 'La tareas:' + values.tarea + 'se ha actualizo correctamente',
                                color : 'succes',
                                show : true
                            }
                        ]
                    );
                    formik.setSubmitting(false);
                }
            }
        }).catch((err) => {
            setShow(false);
            toast.setArrayToast(
                prevState => [
                    ...prevState,
                    {
                        id : idTask,
                        text : 'Hay un error con los datos:' + err.data,
                        color : 'danger',
                        show : true
                    }
                ]
            );
        });
    }

    const formik = useFormik({
        initialValues: {
            id_estatus: task.estatus,
            inicio_proyectado: task.inicio_proyectado,
            termino_proyectado: task.termino_proyectado,
            prioridad: task.prioridad,
            progreso : task.progreso,
            tarea: task.tarea ?? "",
            objetivo:  task.objetivo ?? "",
            notas: task.notas ?? "",
            archivosAdjuntos: task.archivos_adjuntos,
            children: task.children,
        },
        enableReinitialize: true,
        onSubmit
    });

    useEffect(() => {
        formik.dirty ? setItChange(true) : setItChange(false);
    }, [formik.dirty, setItChange]);

    const [cardScroll, setCardScroll] = useState(0)
    const [topCard, setTopCard] = useState(0);
    const perfilRef = useRef(null);

    useEffect(() => {
        // Medidas del componente -> perfilRef.current.getBoundingClientRect()
        setTimeout(() => {
            if (perfilRef.current){
                const topT = 75+44+perfilRef.current.clientHeight;
                setCardScroll(topT);

                const { top } = perfilRef.current.getBoundingClientRect();
                setTopCard(top);
            }
        }, 1000);

    }, [idTask]);

    // function changeStatus() {
    //
    //     const newStatus = {
    //         id_tarea: idTask,
    //         id_origen: task.estatus,
    //         id_destino: formik.values.id_estatus
    //     };
    //
    //     axiosInstance.post('/todo/estatus/', newStatus)
    //         .then((res) => {
    //             if (res.status === 200) {
    //                 setEditStatus(false)
    //                 setSaveStatus(formik.values.id_estatus);
    //                 if (formik.values.id_estatus === 3) {
    //                     setShowPause(true);
    //                 }
    //             }
    //         }).catch((error) => console.log(error));
    // }

    function sentMotivo() {
        axiosInstance.post('/todo/comentarios/', {
            id_tarea: idTask,
            id_usuario: auth.usuario.id_usuario,
            comentario: motivoPausa,
            id_comentario: null
        }).then((res) => {
            if (res.data.id_comentario) {
                setMotivoPausa('');
                setShowPause(false);
            }
        }).catch((err) => console.error(err))
    }
    const res  = () => {
        let value = Math.max(formik.values.progreso - 10, 0);
        formik.setFieldValue('progreso', value);
       // setChangeProgreso(value);
    }

    const sum = () => {
        let value = Math.min(formik.values.progreso + 10, 100);
        formik.setFieldValue('progreso', value);
       // setChangeProgreso(value);
    };

    const status = formik.values.progreso === 100 ? 'success' : null;
    const color = formik.values.progreso === 100 ? '#52c41a' : '#068099';

    return (
        <>
            <style type={"text/css"}>
                {`
                    .bi-diagram-2:before{
                        transform: rotate(-90deg);
                    }
                    
                    .rs-stack{
                        display: block;
                    }
                    
                    .rs-picker{
                        text-transform: capitalize;
                        color: #068099;
                    }
                    
                    .form-control-plaintext{
                        color: #000;
                        font-size: 1.5rem;
                        font-weight: 600;
                    }
                    
                    .wFfx {
                        min-width : -moz-available;
                    }
                    
                    .rs-slider-with-mark:not(.rs-slider-vertical){
                        margin-bottom: 4rem!important;
                    }
                    
                    .top-perfil {
                        top: ${topCard}px;
                        z-index : 5;
                    }
                    
                    .top-nav-perfil {
                        top : ${cardScroll}px; 
                        z-index : 4;
                    }
                    
                    .form-control-plaintext{
                        padding-left: 1rem!important;
                    }
                    
                    .rs-plaintext{
                        padding-left : 1rem!important;
                        padding-right : 2.5rem!important;
                        padding-top : 0.5rem!important;
                        padding-bottom : 0.5rem!important;
                    }
                `}
            </style>

            {/*TAREA*/}
                <div className="container-xxl" id="content_container_perfil">
                    <div className="card position-sticky top-perfil" ref={perfilRef}>
                        <div className="card-body pt-5 pb-2">
                            <div className={"d-flex mb-3"}>
                                {
                                    (task.tareas_padre && task.tareas_padre.length > 0) && task.tareas_padre.map((t) => {
                                        return (

                                            <button type={"button"} className={"btn btn-link fs-4 pt-0 text-primary me-3"}

                                                    onClick={(e) => toggleShow(e, t.id_tarea, t.tarea)}>

                                                <u><i className="bi bi-chevron-right fs-4 text-primary me-3"></i>{t.tarea}</u>

                                            </button>

                                        )
                                    })
                                }
                            </div>
                            <FormikProvider value={formik}>
                                <form onSubmit={formik.handleSubmit}>
                                    <div className="d-flex flex-wrap flex-sm-nowrap">
                                        <div className={'me-7 mb-4'} style={{display: 'inline-block', width: '18%'}}>
                                            <Progress.Circle
                                                percent={formik.values.progreso}
                                                strokeColor={color}
                                                status={status}
                                                strokeWidth={10}
                                                trailWidth={10}
                                            />
                                            <div className={'d-flex pt-2 justify-content-between'}
                                                 style={{height: '3.25rem'}}>
                                                {
                                                    edit && <>
                                                        <button
                                                            type={'button'}
                                                            className={'btn btn-active-light-secondary px-3 py-1 fw-bold'}
                                                            onClick={res}
                                                        >
                                                            <i className="bi bi-dash-circle-dotted text-gray-800 fs-2qx"></i>
                                                        </button>
                                                        <button
                                                            type={"button"}
                                                            className={'btn btn-active-light-primary px-3 py-1 fw-bold'}
                                                            onClick={sum}
                                                        >
                                                            <i className="bi bi-plus-circle-dotted text-primary fs-2qx"></i>
                                                        </button>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <div className="row mb-7">
                                                <div className="col-md-2">
                                                    <Prioridad setFieldValue={formik.setFieldValue}
                                                               values={formik.values.prioridad}
                                                               edit={edit}></Prioridad>
                                                </div>
                                                <div className="col-md-3">
                                                    <InicioProyectado
                                                        setFieldValue={formik.setFieldValue}
                                                        defaultV={new Date(formik.values.inicio_proyectado)}
                                                        edit={edit}
                                                    ></InicioProyectado>
                                                </div>
                                                <div className="col-md-3">
                                                    <FinProyectado
                                                        setFieldValue={formik.setFieldValue}
                                                        defaultV={new Date(formik.values.termino_proyectado)}
                                                        edit={edit}
                                                    ></FinProyectado>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-floating">
                                                        <input
                                                            type={'text'}
                                                            className={"form-control bg-gray-200 text-gray-700 border-0 text-uppercase"}
                                                            name={'dias_proyectados'}
                                                            id={'dias_proyectado'}
                                                            value={task.dias_proyectados ?? ""}
                                                            disabled={true}
                                                        />
                                                        <label htmlFor={'dias_proyectados'} className="text-gray-700">Días
                                                            proyectados</label>
                                                    </div>
                                                </div>
                                                {
                                                    asignado && <div className="col-md-2">
                                                        <div className={'form-floating'}>
                                                            <input
                                                                className={"form-control bg-gray-200 text-gray-700 border-0 text-uppercase"}
                                                                type={'text'}
                                                                id={'asignado'}
                                                                name={'asignado'}
                                                                value={asignado.usuario.username.split(" ")[0]}
                                                                disabled={true}
                                                            />
                                                            <label htmlFor={'asignado'} className={'text-gray-700'}>Persona
                                                                responsable</label>
                                                            {/*<div className="symbol-group symbol-hover me-1">*/}
                                                            {/*    <MiembrosMap user={asignado.usuario.username} avatar={asignado.usuario.avatar}></MiembrosMap>*/}
                                                            {/*</div>*/}
                                                            {/*<span*/}
                                                            {/*    className="pt-1 fw-semibold fs-5 ms-1 text-capitalize me-3"*/}
                                                            {/*    style={{color: "#068099"}}>*/}
                                                            {/*    <div className={'px-0 py-2 min-w-50px mw-75px text-truncate'}>{asignado.usuario.username.split(" ")[0]}</div>*/}
                                                            {/*</span>*/}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className="row mb-7">
                                            {/*<div className="d-flex flex-column w-75">*/}
                                                {/*    <div className="d-flex align-items-center mb-1">*/}
                                                <div className={"col-md-2"}>
                                                    <EstatusTask setFieldValue={formik.setFieldValue}
                                                                 values={formik.values.id_estatus}
                                                                 edit={edit}>
                                                    </EstatusTask>
                                                </div>
                                                <div className={'col-md-10'}>
                                                    <div className={"form-floating"}>
                                                        <input
                                                            className={"form-control form-control-solid text-uppercase"}
                                                            name={'tarea'}
                                                            id={'tarea'}
                                                            value={formik.values.tarea}
                                                            onChange={formik.handleChange}
                                                            //style={{minWidth : '-moz-max-content'}}
                                                            //plaintext={!edit}
                                                            readOnly={!edit}
                                                            ref={target}
                                                            onMouseEnter={() => setPop(true)}
                                                            onMouseLeave={() => setPop(false)}
                                                        />
                                                        <label htmlFor={'tarea'}
                                                               className={"text-gray-700"}>Tarea</label>
                                                    </div>
                                                    <Overlay target={target.current} show={pop}
                                                             placement="bottom-start" offset={1}>
                                                        {(props) => (
                                                            <Tooltip {...props}>{formik.values.notas}</Tooltip>
                                                        )}
                                                    </Overlay>
                                                </div>

                                                {/*</div>*/}
                                                {/*</div>*/}
                                            </div>
                                            <div className={'row mb-7'}>
                                                <div className={'col-md-10'}>
                                                    <div className={'form-floating'}>
                                                <textarea
                                                    className={"form-control form-control-solid text-uppercase resize-none"}
                                                    style={{height: 'auto'}}
                                                    //     plaintext={!edit}
                                                    readOnly={!edit}
                                                    name={'objetivo'}
                                                    value={formik.values.objetivo}
                                                    onChange={formik.handleChange}>
                                                </textarea>
                                                        <label htmlFor={'objetivo'}
                                                               className={"text-gray-700"}>Objetivo</label>
                                                    </div>
                                                </div>
                                                <div
                                                    className="col-md-2 d-flex align-content-center justify-content-end">
                                                    <div className="symbol-group flex-nowrap symbol-hover">
                                                        {
                                                            task.miembros && task.miembros.map((m, index) => {
                                                                return (index < 4 && <MiembrosMap key={m.id_miembro}
                                                                                                  user={m.usuario.username}
                                                                                                  avatar={m.usuario.avatar}></MiembrosMap>)
                                                            })
                                                        }
                                                        <TitleTooltip title={'Agregar miembro'} placement={'top'}>
                                                            <button type={'button'}
                                                                    className={'btn p-0 symbol symbol-35px symbol-circle btn-outline btn-outline-primary btn-active-light-primary'}
                                                                    onClick={() => setShowMiembros(true)}>
                                                                <span
                                                                    className={'symbol-label fw-bold fs-8 bg-white text-primary'}>+{task.miembros && task.miembros.length}</span>
                                                            </button>
                                                        </TitleTooltip>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-end mb-5">
                                        <button type={'button'}
                                                className="btn btn-outline btn-outline-primary me-3"
                                                onClick={() => setAddSubT(true)}>Crear Subtarea
                                        </button>
                                        <button
                                            type={'button'}
                                            className="btn btn-secondary me-3"
                                            onClick={() => {
                                                formik.resetForm()
                                                setEdit(false);
                                            }}>
                                            Cancelar
                                        </button>
                                        {
                                            edit ? (
                                                <button className="btn btn-primary"
                                                        type={'submit'}
                                                        disabled={!formik.dirty}
                                                >
                                                    Guardar
                                                </button>
                                            ) : (
                                                <button
                                                    type={'button'}
                                                    className="btn btn-primary"
                                                    onClick={() => setEdit(true)}>
                                                    Editar tarea
                                                </button>
                                            )
                                        }
                                    </div>
                                </form>
                            </FormikProvider>
                        </div>
                        <div className="separator"></div>
                    </div>
                    <Tabs
                        defaultActiveKey="actividad"
                        id={`tab-perfil-${idTask}`}
                        className="py-3 nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold bg-body position-sticky top-nav-perfil"
                        variant={'underline'}
                    >
                        <Tab eventKey="actividad" tabClassName={'text-active-primary'} title="Actividad">
                            <Comentarios task={task} idTask={idTask}></Comentarios>
                        </Tab>
                        <Tab eventKey="subtareas" tabClassName={'text-active-primary'} title="Subtareas"
                             disabled={task.children && task.children.length === 0}>
                            <Subtareas data={task.children} toggleShow={toggleShow}></Subtareas>
                        </Tab>
                        <Tab eventKey="archivos" tabClassName={'text-active-primary'} title="Archivos adjuntos">
                            <ArchivosAdjuntos archivosAD={archivosAD} setArchivosAD={setArchivosAD}
                                              idTask={idTask}></ArchivosAdjuntos>
                        </Tab>
                    </Tabs>
                </div>
            {/*FIN TAREA*/}

            {/*Mostrar miembros*/}
            <Miembros m={task.miembros} showMiembros={showMiembros} setShowMiembros={setShowMiembros}
                      idTask={idTask}></Miembros>

            {/*Agregar subtarea*/}
            <FormTarea idParent={idTask} showForm={addSubT} setShowForm={setAddSubT}></FormTarea>

            {/* Cambiar de estatus : Pausa */}
            <Modal show={showPause} onHide={() => setShowPause(false)} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Motivo de poner el proyecto en pausa</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <textarea type={"text"} className={'form-control ps-5 resize-none'}
                              rows={'1'}
                              name={'motitvoPausa'}
                              value={motivoPausa}
                              onChange={(e) => setMotivoPausa(e.target.value)}>
                    </textarea>
                </Modal.Body>
                <Modal.Footer>
                    <button type={'button'}
                            className={'btn btn-outline btn-outline-primary btn-active-light-primary me-8'}
                            onClick={sentMotivo} disabled={motivoPausa.length < 0}>Enviar
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Confirmar cambios en los datos */}
            <Modal show={show} onHide={() => setShow(false)} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Guardar cambios</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Hay cambios en los datos de la tarea, guardarlos antes de cerrar la pestaña
                </Modal.Body>
                <Modal.Footer>
                    <button type={'button'}
                            className={'btn btn-outline btn-outline-secondary btn-active-light-secondary me-8'}
                            onClick={() => {
                                formik.resetForm();
                                deleteTab(idTask);
                            }}
                    >
                        Cancelar cambios
                    </button>
                    <button type={'button'}
                            className={'btn btn-outline btn-outline-primary btn-active-light-primary me-8'}
                            onClick={() => {
                                onSubmit(formik.values);
                            }}> Guardar y salir
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
